import { styled } from "@mui/material/styles";
import {
  Drawer,
  Select,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledDrawer = styled(Drawer)`
  min-width: 500px;
  height: 100%;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const StyledDrawerInnerContainer = styled("div")`
  height: 100%;
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledContentContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledText = styled(Text)`
  margin: 20px 0;
`;
